module.exports = "/images/logo_2.png?6aa0b32e6117394dfc4719a78b4a3932";